// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47f20fc7","455":"736b873e"}[chunkId] + ".chunk.js";
};